import { fromJS } from 'immutable';
import { filter } from 'lodash';
import { ENGLISH_LANG } from 'configs/constants';
import i18n from '../../../i18n';

export const actions = {
  ADD_LOADING_MESSAGE: 'ADD_LOADING_MESSAGE',
  REMOVE_LOADING_MESSAGE: 'REMOVE_LOADING_MESSAGE',
  SET_LANGUAGE: 'SET_LANGUAGE',
  TOGGLE_USER_BLOCK: 'TOGGLE_USER_BLOCK',
  SET_ROUTE: 'SET_ROUTE',
};

const defaultState = fromJS({
  loadingMessages: [],
  language: ENGLISH_LANG,
  userBlockCollapse: false,
  activeRoute: 'overview',
});

export default (state = defaultState, { type, payload }) => {
  switch (type) {
    case actions.SET_ROUTE:
      return state.set('activeRoute', payload.data);
    case actions.SET_LANGUAGE:
      i18n.changeLanguage(payload.data);

      return state.set('language', payload.data);
    case actions.ADD_LOADING_MESSAGE:
      return state.set('loadingMessages', [...state.get('loadingMessages'), payload.data]);
    case actions.REMOVE_LOADING_MESSAGE:
      return state.set(
        'loadingMessages',
        filter(state.loadingMessages, (msg) => msg !== payload.data),
      );
    case actions.TOGGLE_USER_BLOCK:
      return state.set('userBlockCollapse', !state.get('userBlockCollapse'));
    default:
      return state;
  }
};
